<template>
  <div v-show='cpntMostrar' class="rf-input-group" :class='cpntClassDivField'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='value !== null'>
      <input 
        :id='cpntId' 
        type="checkbox" 
        data-toggle="toggle"

        :autofocus='cpntAutoFocus'
        :disabled='cpntDisabled'
        :placeholder="cpntPlaceholder"
        :style="'width: ' + cpntWidth"

        :data-on="cpntOn" 
        :data-off="cpntOff" 

        :data-onstyle="cpntOnStyle" 
        :data-offstyle="cpntOffStyle" 
        :data-class="cpntClass" 
        :data-size="cpntSize"
        :checked='cpntValue'
      >

      <span class="rf-barra"></span>
      <label :for='cpntId' :class='"has-" + cpntMensagemTipo'>
        <span v-html='cpntNome'></span>

        <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'
        ></RF-Explica>
      </label>
      <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
    </template>
  </div>
</template>
 
<script>
if (!$().bootstrapToggle) {
  require('bootstrap-toggle')
}

export default {
  name: 'RF-Toggles',
  components: {
    'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
  },
  props: {
    cpntStatus: {
      required: true
    },
    cpntId: {
      required: true,
      type: String
    },
    cpntNome: {
      required: true,
      type: [ String, Number ],
      default: function () {
        return ''
      }
    },
    cpntValue: {
      required: true,
      type: Boolean
    },
    cpntDisabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    cpntMostrar: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    },
    cpntAutoFocus: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    cpntMensagem: {
      type: String,
      required: false,
      default: null
    },
    cpntPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    cpntMensagemTipo: {
      type: String,
      required: false,
      default: null
    },
    cpntFocus: {
      required: false,
      type: [ String, Number ],
      default: function () {
        return ''
      }
    },
    cpntOn: {
      type: String,
      required: false,
      default: 'Sim'
    },
    cpntOff: {
      type: String,
      required: false,
      default: 'Não'
    },
    cpntClass: {
      type: String,
      required: false,
      default: 'fast'
    },
    cpntOnStyle: {
      type: String,
      required: false,
      default: 'primary' // default, primary, success, info, warning, danger
    },
    cpntOffStyle: {
      type: String,
      required: false,
      default: 'default' // default, primary, success, info, warning, danger
    },
    cpntSize: {
      type: String,
      required: false,
      default: 'small' // large, normal, small, mini
    },
    cpntWidth: {
      required: false
    },
    cpntExplica: {
      type: Object,
      required: false
    },
    cpntClassDivField: {
      required: false,
      type: [ String, Array ],
      default: function () {
        return []
      }
    },

    cpntOnChange: {
      required: true,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      status: '',
      value: null
    }
  },
  mounted: function () {
    this.iniciarComponent()
  },
  methods: {
    iniciarComponent: function () {
      var self = this

      self.value = self.cpntValue

      setTimeout(function () {
        $('#' + self.cpntId).bootstrapToggle({
          width: self.cpntWidth
        }).change(function () {
          self.value = $('#' + self.cpntId).prop('checked')

          if (self.value !== self.cpntValue) {
            // EMITE UM EVENTO PARA ATUALIZAR O COMPONENT PAI
            self.cpntOnChange(self.value, self.cpntId)
          }
        })
      }, 300)
    }
  },
  watch: {
    'cpntValue': function () {
      this.value = this.cpntValue

      if (this.cpntValue === true) {
        $('#' + this.cpntId).bootstrapToggle('on')
      } else if (this.cpntValue === false) {
        $('#' + this.cpntId).bootstrapToggle('off')
      }
    }
  }
}
</script>

<style src="../../../../node_modules/bootstrap-toggle/css/bootstrap-toggle.min.css"/>

<style scoped>
/* -=-=-=-=-=-= ESTILO INICIAL =-=-=-=-=-=- */
.rf-input-group {
  position: relative;
  margin-bottom: 30px;
}

/* ------------------ CONFIGURA O INPUT ------------------ */
.rf-input-group > input {
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #CCC;
  padding: 5px 5px 5px 5px;
  color: #292b2c;
 }
/* ------------------ TITULO DO CAMPO ------------------ */
.rf-input-group > label {
  position: absolute;
  left: 0px;
  top: -25px;
  color: var(--color-base-02);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
 }   
  /* ------------------ LOCAL E COR QUE FICA O TITULO DO CAMPO APÓS PREENCHIDO ------------------ */
  .rf-input-group > input:focus ~ label, .rf-input-group > input.rf-input-focus-true ~ label {
    top: -20px;
  }
  /* ------------------ ALTERA A COR CASO NÃO SEJA VALIDADO ------------------ */
    .rf-input-group > input.has-error ~ .rf-barra:before, .rf-input-group > input.has-error ~ .rf-barra:after {
      position: absolute;
      bottom: 1px;
      content: '';
      width: 0px;
      height: 2px;
      background: #a94442;
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      width: 50%;
    }
    .rf-input-group > input:disabled {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      cursor: not-allowed;
    }

  .slow .toggle-group { 
    transition: left 0.7s; 
    -webkit-transition: left 0.7s; 
  }
  .fast .toggle-group { 
    transition: left 0.1s; 
    -webkit-transition: left 0.1s; 
  }
  .quick .toggle-group { 
    transition: none; 
    -webkit-transition: none; 
  }
  .btn-default {
    color: var(--color-base-01);
    background-color: #fff;
    border-color: #ccc;
  }
  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
  }
  .btn-default:hover, .btn-default:focus, .btn-default:active, .btn-default.active, .open > .dropdown-toggle.btn-default {
    color: var(--color-base-01);
    background-color: #e6e6e6;
    border-color: #adadad;
  }
  .btn:hover, .btn:focus {
    color: var(--color-base-01);
    text-decoration: none;
  }
  .toggle-handle {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding-bottom: 0px;
    height: 100%;
    width: 0px;
    border-width: 0 1px;
  }
  .btn-sm, .btn-group-sm > .btn {
    padding: 0.25rem 0.6rem;
    border-radius: 0.2rem;
  }
</style>

<style>
  .rf-input-group > div.toggle > div.toggle-group > label {
    text-shadow: none;
  }
</style>
